export default __webpack_public_path__ + "media/JSM_left.f6c00724d186143caebc88a6ab367ee0.svg";